import React from "react";
import cx from "classnames";

import styles from "./CheckoutCard.module.scss";

/**
 * White card on the grey checkout page.
 *
 * Deliberately not `shared/Card` — that's a Bootstrap `.card` wrapper painted
 * `$gray-5`, and its only consumer is the confirmation page.
 *
 * The card owns its own vertical rhythm: direct children are separated by a
 * rule in `CheckoutCard.module.scss`, so blocks must not bring their own outer
 * padding. Blocks that render `null` produce no DOM node and so don't leave a
 * stray divider behind.
 */
const CheckoutCard = ({ children, className }) => (
  <div className={cx(styles.card, className)}>{children}</div>
);

export default CheckoutCard;
